// extracted by mini-css-extract-plugin
export default {"imgProfile":"Header_imgProfile__5Nqtn"};